module.exports = __webpack_public_path__ + "static/media/tt.8befab9d.png";